@import "@/scss/use-bootstrap-mixins";

.hideCarousel {
  transition: all 0.4s;
  opacity: 0;
}

.title {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 10px !important;
  width: 100%;
  font-size: 22px;

  @include media-breakpoint-up(sm) {
    margin-top: 28px;
    font-size: 38px;
    margin-bottom: 24px !important;
  }
}

.content_container {
  position: relative;
}

.descriptor_wrapper {
  // min-height: 250px;
  display: flex;
  align-items: center;
  // width: calc(100vw - 42px - 112px);
  border-radius: 12px;
  opacity: 0.5;

  @include media-breakpoint-up(lg) {
    width: calc(100vw - 42px - 112px);
    min-height: 157px !important;
    max-height: 157px !important;
    max-width: 400px;
  }
}

.selected {
  .title {
    text-align: left;
    font-weight: 600 !important;
    font-size: 16px;
    margin: 0;
  }

  .description {
    font-weight: 400;
    font-size: 14px;
    margin: 0;
  }

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.mobile {
  display: block;
  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.desktop {
  display: none;
  @include media-breakpoint-up(lg) {
    display: block;
    margin-bottom: 35px;
  }
}

.underline {
  // text-decoration: underline;
  border-bottom: 2px solid #000;
  line-height: 2;
}
